module.exports = __webpack_public_path__ + "static/img/CV.aeec156c.jpg";